import { render, staticRenderFns } from "./home-screen.vue?vue&type=template&id=39502b72&scoped=true&"
import script from "./home-screen.vue?vue&type=script&lang=js&"
export * from "./home-screen.vue?vue&type=script&lang=js&"
import style0 from "./home-screen.vue?vue&type=style&index=0&id=39502b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39502b72",
  null
  
)

export default component.exports